import type { OrganizationUsersActions } from '../../actions/org/types';
import type { IOrganizationUsers } from './types';

const defaultState: IOrganizationUsers = {
    list: [],
    isFetching: false
};

const organizationUsersReducer = (state = defaultState, action: OrganizationUsersActions | null): IOrganizationUsers => {
    if (!action) return { ...state };
    switch (action.type) {
        case 'ORGANIZATION_USERS_FETCH_STARTED':
            return {
                ...state,
                isFetching: true
            };
        case 'ORGANIZATION_USERS_FETCH_FINISHED':
            return {
                ...state,
                list: action.data.list,
                isFetching: false
            };
        case 'ORGANIZATION_USERS_FETCH_FAILED':
            return {
                ...state,
                isFetching: false
            };

        default: {
            return state;
        }
    }
};

export default organizationUsersReducer;
